import React from 'react';
import { toDateInputValue } from '../../utils';

const EntityForm = ({ schema = {}, values = {}, onChange, onSubmit, getOptionLabel = (k, v) => v, memberTypeNames = [] }) => {
  const getFieldOptions = (key, fieldDef) => {
    if (fieldDef?.options) return fieldDef.options;
    if (fieldDef?.optionsSource === 'memberTypeNames' && Array.isArray(memberTypeNames)) {
      return ['Välj', ...memberTypeNames.map(m => m.id)];
    }
    if (fieldDef && fieldDef[2]) return fieldDef[2];
    return null;
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (onSubmit) {
      const formValues = { ...values };
      Object.keys(schema).forEach((key) => {
        const fieldType = schema[key]?.type || schema[key]?.[1] || 'text';
        if (fieldType === 'date' && (formValues[key] === undefined || formValues[key] === null || formValues[key] === '')) {
          formValues[key] = toDateInputValue(new Date());
        }
      });
      onSubmit(formValues);
    }
  };

  return (
    <form className="add-item-form flex flex-column height-100" onSubmit={handleSubmit}>
      {Object.keys(schema).map((key, index) => {
        const options = getFieldOptions(key, schema[key]);
        const fieldLabel = schema[key]?.label || schema[key]?.[0] || key;
        const fieldType = schema[key]?.type || schema[key]?.[1] || 'text';
        const defaultValue = fieldType === 'date' ? toDateInputValue(new Date()) : '';
        const inputValue = (values[key] !== undefined && values[key] !== null && values[key] !== '')
          ? values[key]
          : defaultValue;

        return (
          <div className="flex flex-wrap" key={key || index}>
            <label htmlFor={`add-field-${key}`}>{fieldLabel}:</label>
            {options ? (
              <select
                id={`add-field-${key}`}
                value={values[key] || ''}
                onChange={(e) => onChange ? onChange(key, e.target.value) : null}
              >
                {options.map((option) => (
                  <option key={option} value={option}>
                    {getOptionLabel(key, option)}
                  </option>
                ))}
              </select>
            ) : (
              <input
                id={`add-field-${key}`}
                type={fieldType}
                value={inputValue}
                onChange={(e) => onChange ? onChange(key, e.target.value) : null}
              />
            )}
          </div>
        );
      })}
      <button type="submit" className="button">
        Lägg till
      </button>
    </form>
  );
};

export default EntityForm;
export { EntityForm };
